import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { OrderGroupAdapter } from '../adapters/OrderGroupAdapter';
import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';

/**
 * 発注グループ情報を取得するUseCase
 */
export class GetOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 発注グループ情報を取得する
   * @param keyword - 検索キーワード(発注グループ名)
   */
  public execute = async (keyword?: string): Promise<INetworkResult<IOrderGroup[], Error>> => {
    try {
      const result = await this.repository.getOrderGroup(keyword);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      const resOrderGroup = OrderGroupAdapter.adaptResponseOrderGroup(result.status.data.data);

      return {
        status: {
          type: 'success',
          data: resOrderGroup,
        },
      };
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
